import { render, staticRenderFns } from "./SpecificLogin.vue?vue&type=template&id=00325940&scoped=true"
import script from "./SpecificLogin.vue?vue&type=script&lang=js"
export * from "./SpecificLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00325940",
  null
  
)

export default component.exports